import React, { useState } from 'react';
import { Spacer } from 'src/common';
import { Guard } from '..';
import WorkspaceVariablesForm from 'src/components/formComposed/WorkspaceVariablesForm';
import { Scope } from 'src/components/formComposed/WorkspaceVariablesForm/types';
import styled from 'styled-components';
import { Modal } from '../comps';
import { Head } from './comps/Head';
import TabsMenu from 'src/components/TabsMenu';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { FromCSV } from './forms/FromCSV';
import { CsvImportPreview } from 'src/components/VariableCSVReader/types';

export const StyledModal = styled(Modal)`
  width: 1100px;
  min-height: 200px;
  padding: 0 !important;
  overflow-y: auto;
  max-height: 100%;
  overflow-x: auto;
`;

interface IVariablesWorkspaceModalProps {
  onClose: () => void;
  scope: Scope;
  readOnly?: boolean;
}

export const VariablesWorkspaceModal: React.FC<IVariablesWorkspaceModalProps> = ({ onClose, scope, readOnly }) => {
  const [isCloseRequested, setIsCloseRequested] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [showAssessmentVarOnly, setShowAssessmentVarOnly] = useState(false);
  const [hideEmptyVariables, setHideEmptyVariables] = useState(true);
  const [activeTab, setActiveTab] = useState<'variables' | 'from_csv'>('variables');
  const [pendingCsvImport, setPendingCsvImport] = useState<CsvImportPreview | null>(null);

  const isFormDirty = isDirty || !!pendingCsvImport;

  return (
    <Guard
      onCancel={() => setIsCloseRequested(false)}
      onClose={onClose}
      isOpen={isCloseRequested}
      isDirty={isFormDirty}
      modalComponent={
        <StyledModal onRequestClose={() => setIsCloseRequested(true)} isOpen center={false}>
          <Spacer $px={40} />
          <Head
            scope={scope}
            setShowAssessmentVarOnly={setShowAssessmentVarOnly}
            setHideEmptyVariables={setHideEmptyVariables}
            showAssessmentVarOnly={showAssessmentVarOnly}
            hideEmptyVariables={hideEmptyVariables}
            showHideEmptyVariables={activeTab === 'variables'}
          />
          <Spacer $px={40} />
          <div className="h-padding">
            <TabsMenu
              tabs={[
                { label: 'Variables', value: 'variables', dataCy: 'variables' },
                { label: 'Import From CSV', value: 'from_csv', dataCy: 'from_csv' },
              ]}
              activeTab={activeTab}
              setActiveTab={(tab) => {
                setActiveTab(tab);
                setPendingCsvImport(null);
                mpEvent(MPEvents.ButtonClick, {
                  button: tab === 'variables' ? 'Tab:Variables' : 'Tab:Import From CSV',
                  modal: 'Variables modal',
                  tags: ['VARIABLES'],
                });
              }}
            />
          </div>
          <Spacer $px={45} />
          {activeTab === 'variables' && (
            <WorkspaceVariablesForm
              onClose={onClose}
              onCloseRequest={() => setIsCloseRequested(true)}
              scope={scope}
              onDirtyChange={setIsDirty}
              readOnly={readOnly}
              showAssessmentVarOnly={showAssessmentVarOnly}
              hideEmptyVariables={hideEmptyVariables}
              isModal
            />
          )}
          {activeTab === 'from_csv' && (
            <FromCSV
              scope={scope}
              pendingImport={pendingCsvImport}
              onPendingImportChange={setPendingCsvImport}
              onClose={onClose}
            />
          )}
          <Spacer $px={54} />
        </StyledModal>
      }
    />
  );
};
